import React, {FC, useEffect} from 'react';
import {City, SuggestionCity} from "../../models/dadata/city";
import DadataService from "../../service/DadataService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

interface cityAutocompleteInterface{
    setCity:Function
}
const CityAutocomplete:FC<cityAutocompleteInterface> = ({setCity}) => {
    const [value, setValue] = React.useState<SuggestionCity | null>(null);
    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState<SuggestionCity[]>([]);

    useEffect(()=>{
        async function getCompany(){
            try{
                let newOptions = [] as SuggestionCity[];

                if (value) {
                    newOptions = [value];
                }else {
                    const response=await DadataService.fetchCity(inputValue)
                    response.data.suggestions?.map(item=>{
                        newOptions.push(item);
                    })
                }
                setOptions(newOptions);


            }catch (e) {

            }
        }
        if (inputValue === '') {
            setOptions(value ? [value] : []);
            return undefined;
        }

        getCompany();

    },[value,inputValue])


    return (
        <Autocomplete
            getOptionLabel={(option) => (typeof option === 'string' ? option : option.data.city)}
            filterOptions={(x) => x}
            options={options}
            autoComplete
            includeInputInList
            filterSelectedOptions
            noOptionsText={'Город не найден'}
            value={value}
            onChange={(event: any, newValue: SuggestionCity | null) => {
                setOptions(newValue ? [newValue, ...options] : options);
                setValue(newValue);
                setCity(newValue)
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            renderInput={(params) => (
                <TextField {...params} label="Город" variant="outlined" fullWidth style={{marginBottom:'10px',marginTop:'10px'}}/>
            )}
            renderOption={(option) => {

                return (
                    <Grid container alignItems="center">
                        <Grid item>
                        </Grid>
                        <Grid item xs>
                            <Typography variant="body2">
                                {option.data.city_with_type}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {`${option.data.region}`}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            }}
        />
    );
};

export default CityAutocomplete;